module.exports = __webpack_public_path__ + "yadokari-moshi.webm?ec41ba8483527847baef206ae95c9319";


//////////////////
// WEBPACK FOOTER
// ./static/video/yadokari-moshi.webm
// module id = 209
// module chunks = 0